const SEARCH_SCREEN_TYPES = {
   dashboardBusinessSearch: "DASHBOARD",
   categoryBusinessSearch: "CATEGORY",
   frequentlyOrderedBusinessSearch: "FREQUENTLY_ORDERED",
   topRatedBusinessSearch: "TOP_RATED",
   PopularBusinessSearch: "POPULAR",
   assuredBusinessSearch: "ASSURED",
   newStoresBusinessSearch: "NEW_STORES",
   BRBBusinessSearch: "BRB",
   preOrderBusinessSearch: "PRE_ORDER",
   catalogScreen: "CATALOG"
  };

const ENVIRONMENTS = [
  {
    key: "localhost",
    match: "http://localhost:8000",
    env: "local",
    domain: "http://localhost:8000",
  },
  {
    key: "swifts",
    match: "swifts",
    env: "dev",
    domain: "https://swifts.xirify.com",
  },
  {
    key: "vulture",
    match: "vulture",
    env: "qa",
    domain: "https://vulture.xirify.com",
  },
  {
    key: "uat",
    match: "uat",
    env: "uat",
    domain: "https://uat.xirify.com",
  },
  {
    key: "platform",
    match: "platform",
    env: "platform",
    domain: "https://platform.xirify.com",
  },
  {
    key: "demo",
    match: "demo",
    env: "ecommnxt",
    domain: "https://demo.ecommnxt.com",
  },
  {
    key: "trial",
    match: "trial",
    env: "ecommnxt-trial",
    domain: "https://trial.ecommnxt.com",
  },
  {
    key: "uatadigreen",
    match: "uatadigreen",
    env: "adigreen-uat",
    domain: "https://uatadigreen.ecommnxt.com",
  },
  {
    key: "adigreen",
    match: "adigreen",
    env: "adigreen",
    domain: "https://adigreen.ecommnxt.com",
  },
];

// Special environment keys that use ecommnxt domain structure
const SPECIAL_ENV_KEYS = ["demo", "trial", "adigreen"];

 module.exports = {
   SEARCH_SCREEN_TYPES,
   ENVIRONMENTS,
   SPECIAL_ENV_KEYS,
 }